import {InvHistoryType} from "../interface";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import React from "react";
import {useUser} from "../../../../../util/userContext/UserContext";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    inventoryChangeDetail: InvHistoryType
    btnToggleEdit: () => any;
}

export default function InvHistoryOutgoingView({inventoryChangeDetail, btnToggleEdit}: PropsType) {
    const {goToNavigation} = useGoToNavigation()

    const {user} = useUser();

    // const btnGoToList = () => {
    //     goToNavigation(-1, {}, false)
    // }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">출고 상세보기</h3>
            <div className="filter_toolbar">
                {/* NOTE: 목록 버튼이 필요 없어 보여서 삭제 */}
                {/*<button className="btn btn-outline-primary w-100px h-38px" onClick={btnGoToList}>*/}
                {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록*/}
                {/*</button>*/}
                <button
                    className="btn btn-outline-primary w-100px h-38px ms-40px"
                    onClick={() => {
                        goToNavigation(-1, {}, true);
                    }}
                >
                    <img
                        src={
                            process.env.PUBLIC_URL +
                            "/assets/images/icon_hamburger_btn.png"
                        }
                        alt=""
                    />
                    목록
                </button>
                <AuthorityChecker authorityNames={['outboundWriteYn']}>
                    <button className="btn btn-secondary w-100px h-38px" onClick={btnToggleEdit}>수정
                    </button>
                </AuthorityChecker>
            </div>
        </div>

        <h5 className="subheading">출고 정보</h5>
        <table className="table table-bordered my_table">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>출고번호</th>
                <td colSpan={3}>{inventoryChangeDetail.code}</td>
            </tr>
            <tr>
                <th style={{width: "16.66%"}}>생성자</th>
                <td style={{width: "33.3%"}}>{user?.userName ?? ""}</td>
                <th style={{width: "16.66%"}}>생성일자</th>
                <td>{inventoryChangeDetail.modAt}</td>
            </tr>
            <tr>
                <th>출고처</th>
                <td>{inventoryChangeDetail.accountName}</td>
                <th>출고일자</th>
                <td>{inventoryChangeDetail.changeAt}</td>
            </tr>
            <tr>
                <th>메모</th>
                <td colSpan={3}>{inventoryChangeDetail.memo}</td>
            </tr>
            </tbody>
        </table>

        <div className="table_top mb-10px align-items-end">
            <h6 className="table_stats">출고 품목</h6>
            <div className="table_toolbar"></div>
        </div>

        <table className="table table-bordered my_table mb-0">
            <thead>
            <tr>
                <th style={{width: "10.06%"}}>벤더</th>
                <th style={{width: "10.06%"}}>카테고리</th>
                <th style={{width: "24.5%"}}>품목</th>
                <th style={{width: "13.83%"}}>규격</th>
                <th style={{width: "13.83%"}}>단위</th>
                <th style={{width: "13.83%"}}>출고 수량</th>
                <th>현재재고</th>
            </tr>
            </thead>
            <tbody>
            {inventoryChangeDetail.inventoryChangeResList.length !== 0
                ? inventoryChangeDetail.inventoryChangeResList.map(el =>
                    <tr>
                        <td className="text-center">{el.vendor}</td>
                        <td className="text-center">{el.category}</td>
                        <td className="text-center">{el.newTxtNmItem}</td>
                        <td className="text-center">{el.newTxtStndItem}</td>
                        <td className="text-center">{el.inventoryUnit}</td>
                        <td className="text-center">
                            {el.changeAmount > 0
                                ? <><span className="required">+</span>{el.changeAmount}</>
                                : <span className="required">{el.changeAmount}</span>}
                        </td>
                        <td className="text-center">{el.changeResult}</td>
                    </tr>)
                : <EmptyTableRow colSpan={7}/>
            }
            <tr className="blue">
                <td className="text-center" colSpan={4}>품목 수</td>
                <td className="text-end">{inventoryChangeDetail.inventoryChangeResList.length ?? 0}</td>
                <td className="text-center">총 수량</td>
                <td className="text-end">
                    {inventoryChangeDetail.inventoryChangeResList.reduce((acc, cur) => acc + cur.changeAmount, 0) > 0
                        ? <>
                            <>+</>
                            {inventoryChangeDetail.inventoryChangeResList.reduce((acc, cur) => acc + cur.changeAmount, 0)}
                        </>
                        : <span
                            className="required">{inventoryChangeDetail.inventoryChangeResList.reduce((acc, cur) => acc + cur.changeAmount, 0)}</span>
                    }
                </td>
            </tr>
            </tbody>
        </table>
    </div>
}